<div class="d-flex flex-column">
  <span class="d-flex">
      <input
          class="form-control m-input"
          style="width: 150px;"
          angular-mydatepicker
          #start="angular-mydatepicker"
          (keydown)="$event.preventDefault();"
          (click)="start.toggleCalendar()"
          [options]="startDateOptions"
          [(ngModel)]="startDate"
          [ngValue]="startDate"
          [disabled]="disabled ? true : null"
          (dateChanged)="startDateChanged($event)"
      />
      <i style="position: relative; right: 30px; top: 5px; color: black; font-weight: bold;" (click)="start.toggleCalendar()" class="flaticon-calendar"></i>
      <input
          class="form-control m-input"
          angular-mydatepicker
          #end="angular-mydatepicker"
          (keydown)="$event.preventDefault();"
          (click)="end.toggleCalendar()"
          [options]="endDateOptions"
          [(ngModel)]="endDate"
          [ngValue]="endDate"
          [disabled]="disabled ? true : null"
          style="margin-right:0px; margin-left:10px; width: 150px;"
          (dateChanged)="endDateChanged($event)"
      />
      <i style="position: relative; right: 30px; top: 5px; color: black; font-weight: bold;" (click)="end.toggleCalendar()" class="flaticon-calendar"></i>
      <span style="position: relative; left: 10px; top: 10px; user-select: none; white-space: nowrap;">
          {{ days }} {{ days === 1 ? 'day' : 'days' }}
      </span>
      <img
          [hidden]="!showTooltip"
          src="../../assets/app/media/img/icons/info-icon.png"
          class="tooltip-icon"
          style="position: relative; top: 10px; left: 20px;"
          tooltip='Your subscription must have a minimum of {{minDays}} days.'
      />
  </span>
</div>
